export default __webpack_public_path__ + "static/media/dropdown_button_dots.e4e4557b.svg";